function newCookies(){
    let cookieInfo = $('.cookies');
    checkCookie();


    let cookies_statistics = $('#cookies_statistics'),
        cookies_marketing = $('#cookies_marketing');

    function setCookie(cname, cvalue, exdays){
        let d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ';' + expires + ";path=/";
    }

    function getCookie(cname){

        let name = cname + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return '';
    }

    function checkCookie(){
        let marketing = getCookie('cookies_marketing'),
            statistics = getCookie('cookies_statistics');
        if (marketing !== '' || statistics !== '') {
            cookieInfo.hide();
        } else {
            cookieInfo.show();
        }
    }


    $('[data-show-settings]').on('click', function (){
        $(this).attr('clicked', true);
        $('.cookies .input-wrapper').removeClass('hidden');
    });

    $('[data-accept-cookies]').on('click', function (){
        if ($('[data-show-settings]').attr('clicked')) {
            let marketingChecked = cookies_marketing.is(':checked'),
                statisticsChecked = cookies_statistics.is(':checked');
            setCookie('cookies_marketing', marketingChecked, 365);
            setCookie('cookies_statistics', statisticsChecked, 365);

        } else {
            setCookie('cookies_marketing', true, 365);
            setCookie('cookies_statistics', true, 365);
        }
        cookieInfo.hide();
    });
}

export default {newCookies};


// WEBPACK FOOTER //
// ./src/scripts/cookies.js